export const PROGRAM_TYPE = {
  ACTIVE: 'active',
  INVITES: 'invites',
  HISTORY: 'history',
};

export const PROGRAM_COUNTERS = {
  [PROGRAM_TYPE.ACTIVE]: 'activeCount',
  [PROGRAM_TYPE.HISTORY]: 'historyCount',
  [PROGRAM_TYPE.INVITES]: 'invitationCount',
};

export const MEMBERSHIP_TYPE = {
  ONE_TIME_PURCHASE: 'one_time',
  RECURRENT: 'recurrent',
};



// WEBPACK FOOTER //
// ./src/constants/programs.js